// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"f6c43e59","453":"d201ed6a"}[chunkId] + ".chunk.js";
};